import {Component} from "@angular/core";
import {UserService} from "../../services/data/user.service";
import {AuthentService} from "../../services/authent.service";
import {Router} from "@angular/router";
import {BusinessService} from "../../services/data/business.service";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";

@Component({
    selector: 'login-form',
    template: require('./login-form.component.html')
})

export class LoginFormComponent {
    model:LoginForm = new LoginForm();
    submitted = false;

    constructor(private userService:UserService,
                private authentService:AuthentService,
                private router:Router,
                private businessService:BusinessService,
                private currentBusinessService:CurrentBusinessService) {
    }

    login() {
        this.submitted = true;

        this.userService.getToken(this.model.email, this.model.password)
            .subscribe(
                token => {
                    this.authentService.setToken(token.access_token);
                    this.getPrincipal();
                    this.submitted = false;
                },
                error => {
                    this.submitted = false;
                }
            );
    }

    loadBusinesses():void {
        this.businessService.getBusinesses().subscribe(
            businesses => {
                if (businesses.length > 1) {
                    this.currentBusinessService.changeBusinesses(businesses);
                    this.router.navigateByUrl('/businesses');
                } else if (businesses.length == 1) {
                    this.currentBusinessService.changeBusinesses(businesses);
                    this.currentBusinessService.changeBusiness(businesses[0]);

                    this.businessService.getRight(businesses[0].id).subscribe(
                        right => {
                            this.authentService.setRight(right);
                            this.router.navigateByUrl('/home/events');
                        }
                    );
                } else {
                    this.router.navigateByUrl('/business');
                }

            }
        )
    }

    getPrincipal():void {
        this.userService.getPrincipal()
            .subscribe(
                user => {
                    this.authentService.setUser(user);
                    this.submitted = false;
                    this.loadBusinesses();
                },
                error => {
                }
            );
    }
}

class LoginForm {
    email:string;
    password:string;
}





// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/login-form/login-form.component.ts